import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getManagerProfileOptions } from '../../../../api'
import { EMPTY_LIST } from '../../../../constants/common'
import { getItemsFromIdwellApiResponse } from '../../../../utils/api'
import { FieldStackedLabel } from '../../../Field'
import {
  FormBody,
  FormFieldsContainer,
  FormFieldSelectNG,
  FormInlineNotifications,
  getResponsibleManagersFieldErrorProps,
  RESPONSIBLE_MANAGERS_LIMIT,
  useFormValidationErrorsNotification,
} from '../../../Form'
import { FormikField } from '../../../Formik'
import { useInitiallyOpenSelect } from '../../../Select'
import Text from '../../../Text'
import { toUserSelectItemsFromOption, UserMultiSelect } from '../../../User'

function ProfileResponsibleManagersWidgetFormFields({
  AdditionalFormField,
  ContentComponent = 'div',
  additionalFormFieldProps,
  contentComponentProps,
  fieldLabelKey = 'Widget.ResponsibleManagersListTitleKey',
  fieldName,
  getData = getManagerProfileOptions,
  getDataItems = getItemsFromIdwellApiResponse,
  limit = RESPONSIBLE_MANAGERS_LIMIT,
  loadAllApiParams,
  notifications,
  placeholder,
  toPreparedItems = toUserSelectItemsFromOption,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  const { dirty, isSubmitting, values } = useFormikContext()

  const selectStatesRef = useInitiallyOpenSelect()

  useFormValidationErrorsNotification({
    responsibleManagersFieldName: fieldName,
    onRemoveNotification,
    onSetNotification,
  })

  const handleCancel = useCallback(() => onCancel({ dirty }), [dirty, onCancel])

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: false,
        ButtonClear: false,
        Header: false,
        UploadComponent: false,
        cancelProps: {
          onClick: handleCancel,
        },
        isSubmitting,
        submitProps: {
          isLoading: isSubmitting,
          title: 'Modal.SaveBtnKey',
        },
      }}
    >
      <ContentComponent {...contentComponentProps}>
        <FormInlineNotifications notifications={notifications} />
        <FormFieldsContainer>
          {limit ? (
            <Text isSecondary>
              {t('Widget.ResponsibleManagersLimitTextKey', { limit })}
            </Text>
          ) : null}
          <FormikField
            multi
            Component={FormFieldSelectNG}
            Field={FieldStackedLabel}
            Select={UserMultiSelect}
            controlProps={{
              contentProps: {
                inputProps: {
                  placeholder,
                },
              },
            }}
            emptyValue={EMPTY_LIST}
            fieldComponentProps={{
              label: t(fieldLabelKey, {
                count: values[fieldName]?.length,
              }),
            }}
            getData={getData}
            getDataItems={getDataItems}
            getErrorProps={getResponsibleManagersFieldErrorProps}
            loadAllApiParams={loadAllApiParams}
            name={fieldName}
            selectStatesRef={selectStatesRef}
            toPreparedItems={toPreparedItems}
          />
          {AdditionalFormField ? (
            <AdditionalFormField {...additionalFormFieldProps} />
          ) : null}
        </FormFieldsContainer>
      </ContentComponent>
    </FormBody>
  )
}

export default ProfileResponsibleManagersWidgetFormFields
